import React from 'react';
import { AnchorProps } from '@sls-react/components/Links/A';
import NewTabLink from './NewTabLink';

export const playStoreLink =
  'https://play.google.com/store/apps/details?id=com.sidelineswap.android';

const GooglePlayStoreLink: React.FC<AnchorProps> = ({ children, ...props }) => {
  return (
    <NewTabLink
      href={playStoreLink}
      {...props}
      aria-label="Download our Android App"
    >
      {children}
    </NewTabLink>
  );
};

export default GooglePlayStoreLink;
